module.exports = __webpack_public_path__ + "img/13step-03-02-1_ergebnis.4f1a66c7.png";